import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { selectContext, selectZenMode, setZenMode } from '../redux/features/context/contextSlice';

// Zen mode strips the view down to its card grid, so it only means something
// on a view that has one.
const GRID_TYPES = ['items', 'authors', 'lists', 'sites'];

const FIELDS = ['INPUT', 'TEXTAREA', 'SELECT'];

/**
 * Whether the chrome is currently hidden. Read by each piece that hides itself.
 */
export default function useZenMode() {
  return useSelector(selectZenMode);
}

/**
 * Installs the mode's key. `z` is the whole binding, in and out.
 */
export function useZenShortcuts() {
  const dispatch = useDispatch();
  const zenMode = useZenMode();
  const contextType = useSelector(selectContext)?.type;
  const { pathname } = useLocation();
  const hasGrid = GRID_TYPES.includes(contextType);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (FIELDS.includes(e.target.tagName) || e.target.isContentEditable) return;
      const isZ = (e.key === 'z' || e.code === 'KeyZ')
        && !e.shiftKey && !e.ctrlKey && !e.metaKey && !e.altKey;
      if (!isZ) return;
      if (!zenMode && !hasGrid) return;
      e.preventDefault();
      dispatch(setZenMode(!zenMode));
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [dispatch, hasGrid, zenMode]);

  // Zen mode belongs to the grid you turned it on for: navigating away brings
  // the chrome back rather than landing on a page with no header. Paging moves
  // the query string only, so it survives that.
  useEffect(() => {
    dispatch(setZenMode(false));
  }, [dispatch, pathname]);
}
